import React, { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';
import { formatPhone, capitalizeWords } from '../utils/format';

export const BilgiAlModal = React.memo(function BilgiAlModal({ place, theme, userProfile, onClose }) {
  const isDark = theme === 'dark';
  const C = (k) => {
    const d = isDark;
    const m = {
      bg:d?'#0d1117':'#FFF8F0',surf:d?'#141924':'#FFFAF5',surf2:d?'rgba(255,255,255,0.03)':'rgba(139,92,246,0.04)',
      bord:d?'rgba(255,255,255,0.07)':'rgba(139,92,246,0.10)',bord2:d?'rgba(255,255,255,0.12)':'rgba(139,92,246,0.14)',
      txt:d?'#ffffff':'#1E1048',txt2:d?'rgba(255,255,255,0.5)':'#4B3D7A',
      txt3:d?'rgba(255,255,255,0.25)':'#9B8FBD',inp:d?'rgba(255,255,255,0.05)':'rgba(139,92,246,0.06)',
    };
    return m[k]||'';
  };
  const [form, setForm] = useState({parent_name:'',parent_phone:'',child_name:'',birthdate:'',notes:''});
  const [done, setDone] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    localStorage.removeItem('okulmap_bilgial_form');
    setDone(false);
    setSubmitting(false);
    setForm({
      parent_name: userProfile?.name || '',
      parent_phone: userProfile?.phone || '',
      child_name: '',
      birthdate: '',
      notes: '',
    });
  }, [place?.id]);


  const handleSubmit = async () => {
    if (!form.parent_name || !form.parent_phone || !form.child_name || !form.birthdate) {
      alert('Lütfen zorunlu alanları doldurun.'); return;
    }
    setSubmitting(true);
    // Görünürlük artık okul tarafında (trial+plan check) belirlenir; INSERT default 'school'
    const res = await supabase.from('enrollments').insert({
      school_id: place.id,
      parent_name: form.parent_name,
      parent_phone: form.parent_phone,
      child_name: form.child_name,
      birthdate: form.birthdate || null,
      notes: form.notes || null,
      status: 'pending',
      source: 'okulmap',
    });
    if (res.error) { alert('Hata: '+res.error.message); setSubmitting(false); return; }
    setDone(true);
    localStorage.removeItem('okulmap_bilgial_form');
  };

  const inputStyle = {width:'100%',background:C('inp'),border:'1px solid '+C('bord'),borderRadius:10,padding:'11px 14px',color:C('txt'),fontSize:16,outline:'none',fontFamily:'DM Sans,sans-serif',marginBottom:10,display:'block',boxSizing:'border-box',touchAction:'manipulation'};

  const AGE_GROUPS = ['2-3','3-4','4-5','5-6','6-7','7-8','8-9','9-10'];

  return (
    <div style={{position:'fixed',inset:0,zIndex:1100,display:'flex',alignItems:'center',justifyContent:'center',background:'rgba(0,0,0,0.8)',backdropFilter:'blur(8px)'}}
      onClick={onClose}>
      <div style={{background:C('surf'),borderRadius:20,padding:28,width:400,boxShadow:'0 24px 64px rgba(0,0,0,0.5)',border:'1px solid '+C('bord'),animation:'fadeIn 0.2s ease'}}
        onClick={function(e){e.stopPropagation();}}>
        {done ? (
          <div style={{textAlign:'center',padding:20}}>
            <div style={{fontSize:48,marginBottom:12}}>✅</div>
            <div style={{color:C('txt'),fontSize:16,fontWeight:700,marginBottom:8}}>Talebiniz iletildi!</div>
            <div style={{color:C('txt2'),fontSize:13,lineHeight:1.6}}>{place.name} ile ilgili talebiniz alındı, en kısa sürede dönüş yapılacak.</div>
            <button onClick={onClose} style={{marginTop:16,padding:'10px 24px',borderRadius:10,background:'linear-gradient(135deg,#A8DAFF,#7BB8F0)',border:'none',color:'#000',fontWeight:700,cursor:'pointer'}}>Tamam</button>
          </div>
        ) : (
          <>
            <div style={{fontSize:18,fontWeight:800,color:C('txt'),fontFamily:'Syne,sans-serif',marginBottom:4}}>📋 Bilgi Al</div>
            <div style={{color:C('txt2'),fontSize:13,marginBottom:18}}>{place.name}</div>
            <input placeholder="Veli adı soyadı *" style={inputStyle} value={form.parent_name}
              onChange={e=>setForm(f=>({...f,parent_name:capitalizeWords(e.target.value)}))}/>
            <input placeholder="Telefon numarası *" type="tel" style={inputStyle} value={form.parent_phone}
              onChange={function(e){setForm(f=>({...f,parent_phone:formatPhone(e.target.value)}));}}/>
            <input placeholder="Çocuğun adı *" style={inputStyle} value={form.child_name}
              onChange={function(e){setForm(f=>({...f,child_name:e.target.value}));}}/>
            <select value={form.birthdate}
              onChange={function(e){setForm(function(f){return{...f,birthdate:e.target.value};});}}
              style={{...inputStyle,color:form.birthdate?C('txt'):C('txt3'),cursor:'pointer',appearance:'none',WebkitAppearance:'none',backgroundImage:'url("data:image/svg+xml;utf8,<svg xmlns=\'http://www.w3.org/2000/svg\' width=\'12\' height=\'12\' viewBox=\'0 0 24 24\' fill=\'none\' stroke=\'%239B8FBD\' stroke-width=\'2\'><polyline points=\'6 9 12 15 18 9\'/></svg>")',backgroundRepeat:'no-repeat',backgroundPosition:'right 14px center',paddingRight:36}}>
              <option value="" disabled>Yaş grubu seçin *</option>
              {AGE_GROUPS.map(function(g){
                return <option key={g} value={g} style={{color:'#1E1048'}}>{g} yaş</option>;
              })}
            </select>
            <input placeholder="Notunuz (opsiyonel)" style={inputStyle} value={form.notes}
              onChange={function(e){setForm(f=>({...f,notes:e.target.value}));}}/>
            <button onClick={handleSubmit} disabled={submitting}
              style={{width:'100%',padding:13,borderRadius:12,background:'linear-gradient(135deg,#A8DAFF,#7BB8F0)',border:'none',color:'#000',fontSize:14,fontWeight:700,cursor:submitting?'not-allowed':'pointer',fontFamily:'DM Sans,sans-serif',marginBottom:10}}>
              {submitting?'Gönderiliyor...':'Gönder'}
            </button>
            <button onClick={onClose} style={{width:'100%',padding:10,borderRadius:10,background:'transparent',border:'1px solid '+C('bord'),color:C('txt2'),fontSize:13,cursor:'pointer'}}>İptal</button>
          </>
        )}
      </div>
    </div>
  );
});
